<!-- Action Command Control Toolbar Section -->
<div class="d-flex align-items-center gap-2 mb-3">
  <a class="btn btn-outline-secondary d-inline-flex align-items-center gap-2 shadow-sm fw-medium transition-base"
    routerLink="/nav/qr-code-list">
    <i class="fa-solid fa-arrow-left font-xs"></i>
    <span>Back to List</span>
  </a>
</div>

<!-- Dynamic Status Context Alert Indicator Banner -->
@if (textalert()) {
<div class="alert alert-primary d-flex align-items-center gap-2 border-0 shadow-sm rounded-3 py-2.5 px-3 mb-3"
  role="alert">
  <i class="fa-solid fa-triangle-exclamation text-primary fs-5"></i>
  <div class="small fw-semibold">{{ textalert() }}</div>
</div>
}

<!-- Premium Account Audit Data Table Card Wrapper Layout -->
<div class="card border shadow-sm rounded-4 overflow-hidden bg-white w-100 mb-4">
  <div class="table-responsive m-0">
    <table class="table table-hover align-middle mb-0 text-nowrap">

      <!-- Table Header Structure Matrix -->
      <thead class="table-light border-bottom font-monospace small text-uppercase tracking-wider text-secondary">
        <tr>
          <th scope="col" class="ps-4 py-3" width="70">#</th>
          <th scope="col" class="py-3" style="width: 35%;">User Profile Data</th>
          <th scope="col" class="py-3" style="width: 35%;">Contact & Address</th>
          <th scope="col" class="pe-4 py-3" style="width: 30%;">Points & Status</th>
        </tr>
      </thead>

      <!-- Table Body Data Content Rows Loop -->
      <tbody class="small text-dark">
        @for (user of users(); track user.loginPhone || $index) {
        <tr class="transition-base">

          <!-- Serial Row Identifier -->
          <td class="ps-4 font-monospace fw-semibold text-secondary align-top pt-3">
            {{ user.srNo }}
          </td>

          <!-- Column 1: Administrative Profile Data Grid Block -->
          <td class="align-top pt-3">
            <div class="d-flex flex-column gap-1.5">
              <div class="fw-bold fs-6 text-dark mb-0.5">{{ user.name || 'Anonymous Account' }}</div>
              <div>
                <span class="text-secondary fw-semibold font-monospace font-xs">Phone:</span>
                <span class="font-monospace ms-1 fw-medium">{{ user.loginPhone }}</span>
              </div>
              <div>
                <span class="text-secondary fw-semibold font-xs">Profile:</span>
                <span class="ms-1">{{ user.profile || '-' }}</span>
              </div>
              <div>
                <span class="text-secondary fw-semibold font-xs">Email:</span>
                <span class="ms-1 text-lowercase text-decoration-underline text-secondary">{{ user.email || '-'
                  }}</span>
              </div>
              <div>
                <span class="text-secondary fw-semibold font-xs">Occupation:</span>
                <span class="ms-1">{{ user.occupation || '-' }}</span>
              </div>
              <div class="mt-1">
                <span
                  class="badge bg-body-secondary text-dark border px-2 py-1 font-monospace tracking-wide small shadow-sm">
                  <i class="fa-solid fa-address-card me-1.5 text-secondary"></i>NRC: {{ user.nrc || 'Unspecified' }}
                </span>
              </div>
              @if (user.companyRegisterNo) {
              <div>
                <span
                  class="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle px-2 py-1 font-monospace tracking-wide font-xxs">
                  Registration No: {{ user.companyRegisterNo }}
                </span>
              </div>
              }
            </div>
          </td>

          <!-- Column 2: Contact & Demographics Address Grid Block -->
          <td class="align-top pt-3 text-wrap max-w-350">
            <div class="d-flex flex-column gap-1.5">
              <div class="fw-semibold text-dark mb-0.5">
                <i class="fa-solid fa-location-dot text-secondary me-1.5 font-xs"></i>Primary Location Coordinates
              </div>
              <div class="text-secondary lh-base">
                {{ user.address1 }} {{ user.address2 }} {{ user.address3 }}
              </div>
              <hr class="my-1 opacity-10">
              <div class="row g-2 font-xs">
                <div class="col-6">
                  <span class="text-secondary d-block font-xxs text-uppercase tracking-wider fw-bold">Township</span>
                  <span class="fw-medium text-dark">{{ user.township || '-' }}</span>
                </div>
                <div class="col-6">
                  <span class="text-secondary d-block font-xxs text-uppercase tracking-wider fw-bold">City</span>
                  <span class="fw-medium text-dark">{{ user.city || '-' }}</span>
                </div>
                <div class="col-12 mt-1.5">
                  <span class="text-secondary d-block font-xxs text-uppercase tracking-wider fw-bold">Division /
                    State</span>
                  <span class="fw-medium text-dark">{{ user.divisionState || '-' }}</span>
                </div>
              </div>
            </div>
          </td>

          <!-- Column 3: Ledger Points & System Security Matrix Status Grid Block -->
          <td class="pe-4 align-top pt-3">
            <div class="d-flex flex-column gap-2">

              <!-- Account Balance Points Widgets -->
              <div class="row g-2 mb-1">
                <div class="col-6 border-end pe-2">
                  <span class="text-secondary d-block font-xxs text-uppercase tracking-wider fw-bold">Current Points</span>
                  <span class="font-monospace fw-bold fs-6 text-success">{{ user.currentPoints | number }} pts</span>
                </div>
                <div class="col-6 ps-2">
                  <span class="text-secondary d-block font-xxs text-uppercase tracking-wider fw-bold">Total Points</span>
                  <span class="font-monospace fw-bold fs-6 text-primary">{{ user.totalPoints | number }} pts</span>
                </div>
                <div class="col-12">
                  <span class="text-secondary font-monospace font-xxs">
                    <i class="fa-regular fa-clock me-1"></i>Sync: {{ user.currentPointsTs | dateFormat }}
                  </span>
                </div>
              </div>

              <!-- Status Checking Badges Arrays Layer -->
              <div class="d-flex flex-wrap gap-1.5 align-items-center mt-1">

                <!-- Legal Integrity Inspection Guard -->
                @if (user.hasIllegalClaims) {
                <span
                  class="badge bg-danger-subtle text-danger border border-danger-subtle px-2 py-1 rounded-pill font-xxs bg-opacity-25 animate-pulse">
                  <i class="fa-solid fa-triangle-exclamation"></i> Suspect Claims
                </span>
                } @else {
                <span
                  class="badge bg-success-subtle text-success border border-success-subtle px-2 py-1 rounded-pill font-xxs bg-opacity-25">
                  <i class="fa-solid fa-circle-check"></i> Claims Clear
                </span>
                }

                <!-- Core System Access Node State -->
                @if (user.enabled) {
                <span
                  class="badge bg-info-subtle text-info border border-info-subtle px-2 py-1 rounded-pill font-xxs bg-opacity-25">
                  <i class="fa-solid fa-unlock"></i> Login Enabled
                </span>
                } @else {
                <span
                  class="badge bg-secondary-subtle text-secondary border border-secondary-subtle px-2 py-1 rounded-pill font-xxs bg-opacity-25">
                  <i class="fa-solid fa-user-slash"></i> Suspended
                </span>
                }

              </div>

              <!-- Messaging Logs Matrix Indicators -->
              <div class="d-flex gap-2 font-xxs font-monospace mt-1 text-secondary">
                <div class="d-flex align-items-center gap-1">
                  <i class="fa-solid fa-envelope" [class.text-primary]="user.hasMessages"></i>
                  <span>Inbox: {{ user.hasMessages ? 'YES' : 'NO' }}</span>
                </div>
                <div class="d-flex align-items-center gap-1 border-start ps-2">
                  <i class="fa-solid fa-bell" [class.text-warning]="user.hasNewMessages"></i>
                  <span [class.fw-bold]="user.hasNewMessages" [class.text-warning]="user.hasNewMessages">
                    New: {{ user.hasNewMessages ? 'YES' : 'NO' }}
                  </span>
                </div>
              </div>

            </div>
          </td>

        </tr>
        } @empty {
        <!-- Empty Data State Screen Fallback Placement Grid Placeholder -->
        <tr>
          <td colspan="10" class="text-center py-5 text-body-secondary">
            <i class="bi bi-inbox fs-2 d-block mb-2 opacity-50 text-body-secondary"></i>
            No Qr Code records matched your parameters.
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>